import { useEffect, useState } from 'react';
import { fetchOrgBooking } from '../../../pages/orgBooking/orgBookingFun/fetchOrgBookings';
import BookingTable from './bookingTable/BookingTable';

export default function Bookings({ packData, refresh }) {
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState([]);
    const [offSet, setOffSet] = useState(0);
    useEffect(() => {
        const fetchBookingData = async () => {
            fetchOrgBooking(0, setBookings, setLoading, offSet, packData._id, '', 'upcoming');
        };
        fetchBookingData();
        //eslint-disable-next-line
    }, [offSet, packData._id]);

    return (
        <>
            <BookingTable bookingData={bookings} tripStatus={'Upcoming'} setLoading={setLoading} refresh={refresh} />
        </>
    );
}
